// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarTipoRetornoEstatistica,
  getTipoRetornoConfiguracoesEstatisticaSelecionada,
  getTipoRetornoEstatistica,
} from "../../../../state";

export default function SelecaoTipoRetornoEstatistica() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"Comum.Tipo"}
        itensSelector={getTipoRetornoEstatistica}
        selectorItemSelecionado={
          getTipoRetornoConfiguracoesEstatisticaSelecionada
        }
        onItemChange={selecionarTipoRetornoEstatistica}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
        radioName="tipoRetorno"
      />
    </div>
  );
}
